export default "__VITE_ASSET__BG7MJ5fH__"